import React from 'react';
import api from './api';
import CustomDataTable from './CustomDataTable';

class Recommendations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      recommendations: [],
      filters: {
        recommendation: '',
        qty: '',
        days: '',
        not: '',
        remarks: ''
      },
      modRows: [],
      selectedRows: []
    };

    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleCellChange = this.handleCellChange.bind(this);
    this.handleSeqChange = this.handleSeqChange.bind(this);
  }

  componentDidMount() {
    this.fetchRecomms();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.patientCard !== this.props.patientCard ||
      prevProps.summary !== this.props.summary
    ) {
      this.fetchRecomms();
    }
  }

  fetchRecomms() {
    var ur = '';
    var patientCard = this.props.patientCard;
    var summary = this.props.summary;

    if (patientCard) {
      ur = summary
        ? 'patients/consultation/recommendations/' + patientCard
        : 'recommendations/' + patientCard + '/type';
    } else {
      ur = 'recommendations/profiles';
    }

    var that = this;
    api
      .get(process.env.REACT_APP_URL + '/' + ur)
      .then(function (res) {
        that.setState({ recommendations: res.data || [], modRows: [], selectedRows: [] });
      })
      .catch(function (err) {
        console.error(err);
      });
  }

  handleFilterChange(key, value) {
    var filters = Object.assign({}, this.state.filters);
    filters[key] = value;
    this.setState({ filters: filters });
  }

  passesFilter(row) {
    var f = this.state.filters;
    return (
      (row.recommendation || '').toLowerCase().indexOf(f.recommendation.toLowerCase()) !== -1 &&
      String(row.qty || '').toLowerCase().indexOf(f.qty.toLowerCase()) !== -1 &&
      String(row.days || '').toLowerCase().indexOf(f.days.toLowerCase()) !== -1 &&
      String(row.not || '').toLowerCase().indexOf(f.not.toLowerCase()) !== -1 &&
      (row.remarks || '').toLowerCase().indexOf(f.remarks.toLowerCase()) !== -1
    );
  }

  prefilledSelectionCriteria(row) {
    var isSelected = this.state.selectedRows.some(function (r) {
      return r._id === row._id;
    });
    var isPreSelected = row && row.parentId && row.parentId !== '';
    return isSelected || isPreSelected;
  }

  handleCellChange(key, idx, e) {
    var value = e.target.value;

    this.setState(function (prevState) {
      var recs = prevState.recommendations.slice();
      var updatedRow = Object.assign({}, recs[idx], {});
      updatedRow[key] = value;
      recs[idx] = updatedRow;

      var modRowsCopy = prevState.modRows.slice();
      var foundMod = false;
      for (var i = 0; i < modRowsCopy.length; i++) {
        if (modRowsCopy[i]._id === updatedRow._id) {
          modRowsCopy[i] = updatedRow;
          foundMod = true;
          break;
        }
      }
      if (!foundMod) {
        modRowsCopy.push(updatedRow);
      }

      var selectedCopy = prevState.selectedRows.slice();
      var foundSel = false;
      for (var j = 0; j < selectedCopy.length; j++) {
        if (selectedCopy[j]._id === updatedRow._id) {
          selectedCopy[j] = updatedRow;
          foundSel = true;
          break;
        }
      }
      if (!foundSel) {
        selectedCopy.push(updatedRow);
      }

      setTimeout(function () {
        if (this.props.onDataChange) {
          var combined = [];
          var map = {};
          for (var k = 0; k < selectedCopy.length; k++) {
            map[selectedCopy[k]._id] = selectedCopy[k];
          }
          for (var l = 0; l < modRowsCopy.length; l++) {
            map[modRowsCopy[l]._id] = modRowsCopy[l];
          }
          for (var m in map) {
            combined.push(map[m]);
          }
          this.props.onDataChange(combined);
        }
      }.bind(this), 0);

      return {
        recommendations: recs,
        modRows: modRowsCopy,
        selectedRows: selectedCopy
      };
    }.bind(this));
  }

  handleSeqChange(e) {
    var selected = e.selectedRows || [];
    this.setState({ selectedRows: selected }, function () {
      var combined = [];
      var map = {};
      for (var i = 0; i < selected.length; i++) {
        map[selected[i]._id] = selected[i];
      }
      for (var j = 0; j < this.state.modRows.length; j++) {
        map[this.state.modRows[j]._id] = this.state.modRows[j];
      }
      for (var k in map) {
        combined.push(map[k]);
      }

      if (this.props.onDataChange) {
        this.props.onDataChange(combined);
      }
    }.bind(this));
  }

  render() {
    var filters = this.state.filters;
    var recs = this.state.recommendations;
    var rowsToShow = (recs || [])
      .filter(this.passesFilter.bind(this))
      .sort(function (a, b) {
        var ap = a.parentId && a.parentId !== '' ? 0 : 1;
        var bp = b.parentId && b.parentId !== '' ? 0 : 1;
        return ap - bp;
      });

    var columns = [
      {
        name: 'Recommendation',
        selector: function (row) { return row.recommendation; },
        cell: function (row) {
          return <span>{row.recommendation}</span>;
        },
        sortable: true
      },
      {
        name: 'Quantity',
        selector: function (row) { return row.qty; },
        cell: function (row) {
          var idx = recs.findIndex(function (r) { return r._id === row._id; });
          return (
            <input
              type="text"
              className="table-number-input"
              value={row.qty || ''}
              onChange={this.handleCellChange.bind(this, 'qty', idx)}
            />
          );
        }.bind(this),
        sortable: true
      },
      {
        name: 'No. of Days',
        selector: function (row) { return row.days; },
        cell: function (row) {
          var idx = recs.findIndex(function (r) { return r._id === row._id; });
          return (
            <input
              type="text"
              className="table-number-input"
              value={row.days || ''}
              onChange={this.handleCellChange.bind(this, 'days', idx)}
            />
          );
        }.bind(this),
        sortable: true
      },
      {
        name: 'No. of Times',
        selector: function (row) { return row.not; },
        cell: function (row) {
          var idx = recs.findIndex(function (r) { return r._id === row._id; });
          return (
            <input
              type="text"
              className="table-number-input"
              value={row.not || ''}
              onChange={this.handleCellChange.bind(this, 'not', idx)}
            />
          );
        }.bind(this),
        sortable: true
      },
      {
        name: 'Remarks',
        selector: function (row) { return row.remarks; },
        cell: function (row) {
          var idx = recs.findIndex(function (r) { return r._id === row._id; });
          return (
            <input
              type="text"
              className="table-text-input"
              value={row.remarks || ''}
              onChange={this.handleCellChange.bind(this, 'remarks', idx)}
            />
          );
        }.bind(this),
        sortable: true
      }
    ];

    return (
      <div>
        <h4>Recommendations</h4>
        {rowsToShow.length > 0 ? (
          <CustomDataTable
            columns={columns}
            data={rowsToShow}
            selectableRows={true}
            selectableRowSelected={this.prefilledSelectionCriteria.bind(this)}
            onSelectedRowsChange={this.handleSeqChange}
            paginationPerPage={10}
          />
        ) : (
          <div style={{ marginTop: '10px' }}>No recommendations to show</div>
        )}
      </div>
    );
  }
}

export default Recommendations;
